module.exports = __webpack_public_path__ + "img/signature-green.5070ab76.svg";